

import Header from "../components/Header";
import BtnLink from "../components/BtnLink";
export default {
    props: ['error'],
    components: {BtnLink, Header},
    created() {

    },
    methods: {

    },
    computed: {
        errorPage() {
            if (this.error.statusCode === 404) {
                return 404;
            }
            // catch everything else
            return 500;
        },
    },
}
